export default {
  async setTweets({commit}, incidents) {
    commit('SET_INCIDENTS', incidents);
  },
}
